"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("./FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This layout is often used as a dashboard widget with header and footer
 */
var HeaderFooterLayout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(HeaderFooterLayout, _React$Component);

  function HeaderFooterLayout() {
    _classCallCheck(this, HeaderFooterLayout);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeaderFooterLayout).apply(this, arguments));
  }

  _createClass(HeaderFooterLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          header = _this$props.header,
          bodyContent = _this$props.bodyContent,
          footer = _this$props.footer,
          headerProps = _this$props.headerProps,
          footerProps = _this$props.footerProps,
          bodyContentProps = _this$props.bodyContentProps,
          props = _objectWithoutProperties(_this$props, ["className", "header", "bodyContent", "footer", "headerProps", "footerProps", "bodyContentProps"]);

      var headerNode = header ? _react.default.createElement(_FlexLayout.default, _extends({
        className: "header",
        alignItems: "center"
      }, headerProps), header) : null;
      var footerNode = footer ? _react.default.createElement(_FlexLayout.default, _extends({
        className: "footer",
        alignItems: "center"
      }, footerProps), footer) : null;

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      var mergedClassName = (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-header-footer-layout"), className);
      return _react.default.createElement(_FlexLayout.default, _extends({
        className: mergedClassName,
        flexDirection: "column",
        itemSpacing: "0px"
      }, props), headerNode, _react.default.createElement(_FlexLayout.default, _extends({
        className: "body-content"
      }, bodyContentProps), bodyContent), footerNode);
    }
  }]);

  return HeaderFooterLayout;
}(_react.default.Component);

exports.default = HeaderFooterLayout;
HeaderFooterLayout.propTypes = {
  /**
   * Additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Header element.  40px height
   */
  header: _propTypes.default.node,

  /**
   * Body element.  By default the body will display a scroll if overflow.
   */
  bodyContent: _propTypes.default.node.isRequired,

  /**
   * Footer element. 40px height
   */
  footer: _propTypes.default.node,

  /**
   * Customised Header Properties.
   * Refer FlexLayout Properties for options.
   */
  headerProps: _propTypes.default.object,

  /**
   * Customised Footer Properties.
   * Refer FlexLayout Properties for options.
   */
  footerProps: _propTypes.default.object,

  /**
   * Customised Body Content Properties.
   * Refer FlexLayout Properties for options.
   */
  bodyContentProps: _propTypes.default.object
};